.simplero-modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 100000000; /* Sit on top */
  padding-top: 50px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.8); /* Black w/ opacity */
  cursor: pointer; // needed to work in iOS
}

.simplero-modal-in-live-edit-mode{
  padding: 2rem;
  background: gray;

  .modal-edit-mode-notice{
    margin-top: 1rem;
    text-align: center;
    p{
      color: white;
      font-size: 14px;
      font-weight: bold;
      font-style: italic;
    }
  }
}

/* Modal Content */
.simplero-modal-content {
  background-color: white;
  margin: auto;
  width: 60%;
  @media screen and (max-width: 600px) {
    width: 80%;
  }
}